import {Routes} from '@angular/router';
import {DashboardPageComponent} from "./pages/dashboard-page/dashboard-page.component";
import {inject} from "@angular/core";
import {AuthService} from "./services/auth.service";
import {UserPageComponent} from "./pages/user-page/user-page.component";
import {ApplicationsTabComponent} from "./pages/applications-tab/applications-tab.component";
import {ApartmentPageComponent} from "./pages/apartment-page/apartment-page.component";
import {UsersTabComponent} from "./pages/dashboard-page/users-tab/users-tab.component";
import {ApartmentsTabComponent} from "./pages/dashboard-page/apartments-tab/apartments-tab.component";
import {EmailsTabComponent} from "./pages/dashboard-page/emails-tab/emails-tab.component";
import {CancelTabComponent} from "./pages/cancel-tab/cancel-tab.component";
import {BetterUsersOverviewComponent} from "./pages/better-users-overview/better-users-overview.component";
import {DelayedApplicationsTabComponent} from "./pages/delayed-applications-tab/delayed-applications-tab.component";
import {NotificationTestPageComponent} from "./pages/notification-test-page/notification-test-page.component";
import {ExportsTabComponent} from "./pages/exports-tab/exports-tab.component";
import {DomainEventsPageComponent} from "./pages/domain-events-page/domain-events-page.component";
import {ManualNotificationCheckPageComponent} from "./pages/manual-notification-check-page/manual-notification-check-page.component";
import {ApplicationCreatePageComponent} from "./pages/application-create-page/application-create-page.component";

export const routes: Routes = [
  {
    path: '',
    component: DashboardPageComponent,
    canActivate: [() => inject(AuthService).authorize()],
    children: [
      {
        path: '',
        pathMatch: "full",
        redirectTo: 'users'
      },
        {
          path: 'users',
          children: [
            {
              path: '',
              pathMatch: "full",
              component: UsersTabComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId/notification-test',
              component: NotificationTestPageComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId/application-create',
              component: ApplicationCreatePageComponent,
              data: {
                tab: 'users'
              }
            },
            {
              path: ':userId',
              component: UserPageComponent,
              data: {
                tab: 'users'
            }
          }
        ]
      },
      {
        path: 'new-users',
        component: BetterUsersOverviewComponent
      },
      {
        path: 'apartments',
        children: [
          {
            path: ":apartmentId",
            component: ApartmentPageComponent,
            data: {
              tab: 'apartments'
            }
          },
          {
            path: "",
            pathMatch: "full",
            component: ApartmentsTabComponent,
            data: {
              tab: 'apartments'
            }
          },
        ]
      },
      {
        path: "emails",
        children: [
          {
            path: '',
            pathMatch: "full",
            component: EmailsTabComponent,
            data: {
              tab: 'emails'
            }
          }
        ]
      },
      {
        path: 'failed-applications',
        children: [
          {
            path: '',
            pathMatch: "full",
            component: ApplicationsTabComponent,
            data: {
              tab: 'failed-applications'
            }
          },
        ]
      },
      {
        path: 'delayed-applications',
        children: [
          {
            path: '',
            pathMatch: "full",
            component: DelayedApplicationsTabComponent,
            data: {
              tab: 'delayed-applications'
            }
          },
        ]
      },
      {
        path: "cancels",
        component: CancelTabComponent
      },
      {
        path: "exports",
        component: ExportsTabComponent,
        data: {
          tab: 'exports'
        }
      },
      {
        path: "domain-events",
        component: DomainEventsPageComponent,
        data: {
          tab: 'domain-events'
        }
      },
      {
        path: 'notification-check',
        component: ManualNotificationCheckPageComponent,
        data: {
          tab: 'notification-check'
        }
      }
    ]
  },
  {
    path: 'callback',
    redirectTo: '',
  }
];
